const data = [
	{
		id:"work37",
		imgLink: "https://ik.imagekit.io/hbj42mvqwv/Capture_FLJY-AKlP.JPG",
		tag: ['React', 'Javascript', 'Professional'],
		link: 'https://talnt.pro/',
		overlayTitle: "TALNT",
		tech: "React"
	},
	{
		id:"work38",
		imgLink: "https://ik.imagekit.io/hbj42mvqwv/Capture_1__aa0bDf_ee.JPG",
		tag: ['React', 'Javascript', 'Professional'],
		link: 'https://www.fivefalcon.com/',
		overlayTitle: "FiveFalcon Portfolio",
		tech: "React"
	},
	{
		id:"work36",
		imgLink: "https://ik.imagekit.io/hbj42mvqwv/Capture_1__gAmoy1tIt.JPG",
		tag: ['React', 'Javascript', 'Professional'],
		link: 'https://www.khelauction.com/',
		overlayTitle: "Khel Auction",
		tech: "MERN STACK"
	},
	{
		id:"work28",
		imgLink: "https://ik.imagekit.io/hbj42mvqwv/Capture_1__Fy6psDI__.JPG",
		tag: ['React', 'Javascript', 'Professional'],
		link: 'https://www.noteslelo.com',
		overlayTitle: "NOTES LELO",
		tech: "MERN STACK"
	},
	{
		id:"work29",
		imgLink: "https://ik.imagekit.io/hbj42mvqwv/Capture_sRh8XULku.JPG",
		tag: ['React', 'Javascript', 'Personal'],
		link: 'https://rt-gaming-hub.netlify.app/',
		overlayTitle: "Real Time Dice Game",
		tech: "MERN STACK"
	},
	{
		id: "work1",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/site7__1__ir-QdljF_3.png', 
		tag: ['Javascript' ,'Personal'],
		link : 'https://the-witcher-wiki.netlify.app',
		overlayTitle : "The Witcher Wiki",
		tech : "Vue.Js"
	},
	{
		id: "work2",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/site3_2ZP7xIsTBt.png',
		tag : ['React', 'Personal'],
		link : 'https://kamalnanda.github.io/movieapp.github.io',
		overlayTitle : "Movie DB",
		tech : "React.Js"
	},
	{
		id: "work19",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/Untitled1_yzM8urpWK.png',
		tag : ['React', 'Personal'],
		link : 'https://instagram-clone-kamalnanda.netlify.app',
		overlayTitle : "Instagram Clone",
		tech : "React.Js"
	},
	{
		id: "work20",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/Untitled_3BmGJF-ps.png',
		tag : ['React' , 'Personal'],
		link : 'https://the-rick-and-morty-wiki.netlify.app',
		overlayTitle : "Rick and Morty Wiki",
		tech : "React"
	},
	{
		id: "work3",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/site6_G4diM9BYJR.png',
		tag : ['Javascript' , 'Professional'],
		link : 'https://iycn.in',
		overlayTitle : "IYCN",
		tech : "Javascript"
	},
	{
		id: "work7",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/screenshot_Thu_May_21_14.07.20_V5RhhH2HaK.png',
		tag : ['Javascript' , 'Professional'],
		link : 'https://k4tools.com',
		overlayTitle : "K4TOOLS",
		tech : "Javascript"
	},
	
	{
		id: "work9",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/screenshot_Thu_May_21_14.015.20_-b6VcwHf27.png',
		tag : ['Javascript' , 'Personal'],
		link : 'https://send-love-button.netlify.app',
		overlayTitle : "Send Love Button",
		tech : "Javascript"
	},
	
	{
		id: "work5",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/Untitled_V4aBwOC0_.png',
		tag : ['React' ,'Personal'],
		link : 'https://cat-mates.netlify.app',
		overlayTitle : "Cat Mates",
		tech : "React.Js"
	},
	{
		id: "work18",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/Untitled_jFKK6P9Mn.png',
		tag : ['Javascript' , 'Personal'],
		link : 'https://github.com/KamalNanda/KBot-Discord-Lyrics-Bot',
		overlayTitle : "Discord Lyrics Bot",
		tech : "Javascript"
	},
	{
		id: "work6",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/site1_fLAj5p4KB.png',
		tag : ['Javascript', 'Professional'],
		link : 'https://vipsace.org/portal',
		overlayTitle : "ACE Registeration Portal",
		tech : "Javascript"
	},
	{
		id: "work17",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/Untitled_1JkDD4LS2G.png',
		tag : ['Javascript' , 'Personal'],
		link : 'https://github.com/KamalNanda/IMDB-SCRAPER',
		overlayTitle : "IMDB Scrapper",
		tech : "Javascript"
	},
	{
		id: "work15",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/Untitled_Rb75qUH6Pz.png',
		tag : ['UiUx' , 'Personal'],
		link : 'https://kamalnanda.github.io',
		overlayTitle : "Portfolio",
		tech : "UI/UX design"
	},
	{
		id: "work10",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/WhatsApp_Image_2020-06-19_at_21.51.25_SvrnCEtuh.jpeg',
		tag : ['graphics' , 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/WhatsApp_Image_2020-06-19_at_21.51.25_SvrnCEtuh.jpeg',
		overlayTitle : "Desert Scene",
		tech : "Photoshop"
	},
	{
		id: "work14",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/WhatsApp_Image_2020-06-19_at_21.51.25__1__CptPoCTWdC.jpeg',
		tag : ['graphics' , 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/WhatsApp_Image_2020-06-19_at_21.51.25__1__CptPoCTWdC.jpeg',
		overlayTitle : "Beach Scene",
		tech : "Photoshop"
	},
	{
		id: "work11",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/captain_wall_Z5qhlFbs6.png',
		tag : ['graphics' , 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/captain_wall_Z5qhlFbs6.png',
		overlayTitle : "Captain America",
		tech : "Photoshop"
	},
	{
		id: "work32",
		type:'frame',
		imgLink : 'https://www.youtube.com/watch?v=v3ygoQUymxg',
		embedLink:'https://www.youtube.com/embed/v3ygoQUymxg',
		tag : ['Video Editing' , 'Personal'],
		link : 'https://www.youtube.com/watch?v=v3ygoQUymxg',
		overlayTitle : "Assassin's Creed feat. Bezubaah phir se- ABCD2",
		tech : "Premier Pro"
	}, 
	{
		id: "work33",
		type:'frame',
		imgLink : 'https://www.youtube.com/watch?v=ijNxESUnj0E',
		embedLink:'https://www.youtube.com/embed/ijNxESUnj0E',
		tag : ['Video Editing' , 'Personal'],
		link : 'https://www.youtube.com/watch?v=ijNxESUnj0E',
		overlayTitle : "Assassin's Creed ft. Allah Duhai ",
		tech : "Premier Pro"
	}, 
	{
		id: "work31",
		type:'frame',
		imgLink : 'https://www.youtube.com/watch?v=pftDqr-ZTNc',
		embedLink:'https://www.youtube.com/embed/pftDqr-ZTNc',
		tag : ['Video Editing' , 'Personal'],
		link : 'https://www.youtube.com/watch?v=pftDqr-ZTNc',
		overlayTitle : "Industrial Visit - Haploos Printing Press",
		tech : "Filmora, Camtasia 2018"
	}, 
	{
		id: "work12",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/black_panther_-yOwwfHYx.png',
		tag : ['graphics' , 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/black_panther_-yOwwfHYx.png',
		overlayTitle : "Black Panther",
		tech : "Illustrator"
	},
	{
		id: "work22",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/slingsy5_XmGEDSX0g.png',
		tag : ['graphics' , 'Professional'],
		link : 'https://slingsydigital.com',
		overlayTitle : "Slingsy Digital",
		tech : "Illustrator"
	},
	{
		id: "work23",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/space_man_final_WZIk-vL8u.png',
		tag : ['graphics' , 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/space_man_final_WZIk-vL8u.png',
		overlayTitle : "A mess of unfinished thoughts",
		tech : "Illustrator"
	},
	{
		id: "work24",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/Diamond_Head_rh_De3hET.png',
		tag : ['graphics' , 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/Diamond_Head_rh_De3hET.png',
		overlayTitle : "Time is the greatest Destroyer",
		tech : "Illustrator"
	},
	{
		id: "work25",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/messi-5_4khxvxcDhg.png',
		tag : ['graphics' , 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/space_man_final_WZIk-vL8u.png',
		overlayTitle : "Digital Portrait Lionel Messi",
		tech : "Illustrator"
	},
	{
		id: "work21",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/Artboard_10_4x_6uFJ1t7sW.png',
		tag : ['graphics' , 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/Artboard_10_4x_6uFJ1t7sW.png',
		overlayTitle : "Goku Digital Art",
		tech : "Illustrator"
	},
	{
		id: "work26",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/WhatsApp_Image_2020-09-07_at_13.03.41__1__ncD39iuSG.jpeg',
		tag : ['graphics' , 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/WhatsApp_Image_2020-09-07_at_13.03.41__1__ncD39iuSG.jpeg',
		overlayTitle : "Dobby - A Free Elf",
		tech : "Illustrator"
	},
	{
		id:"work27",
		imgLink: "https://ik.imagekit.io/hbj42mvqwv/IMG_20210207_002059_130_5zTU7WxlK5V.png",
		tag: ['graphics', 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/IMG_20210207_002059_130_5zTU7WxlK5V.png',
		overlayTitle: "Robo Love",
		tech: "Illustrator"
	},
	{
		id: "work27",
		imgLink : 'https://ik.imagekit.io/hbj42mvqwv/WhatsApp_Image_2020-09-07_at_13.03.41__7Ga5fzGf.jpeg',
		tag : ['graphics' , 'Personal'],
		link : 'https://ik.imagekit.io/hbj42mvqwv/WhatsApp_Image_2020-09-07_at_13.03.41__7Ga5fzGf.jpeg',
		overlayTitle : "The Boy Who Lived",
		tech : "Illustrator"
	},
	{
		id: "work34",
		type:'frame',
		imgLink : 'https://youtu.be/W1rF74_y67s',
		embedLink:'https://www.youtube.com/embed/W1rF74_y67s',
		tag : ['Video Editing' , 'Personal'],
		link : 'https://youtu.be/W1rF74_y67s',
		overlayTitle : "Stickman Animation - When your mom finds out that you fails in your exam",
		tech : "Camtasia"
	}
]
export default data